import React, { useContext, useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import ReactPlayer from "react-player";
import { serverInfo } from "../../../App";
// import "./AuditionCardReuse.css";
// import tik from "../../../assets/images/Rounds/sign.png";

const RoundAssessmentResultTable = (props) => {
  const { videoCdnUrl } = useContext(serverInfo);
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 5;
  const { data, tableHead, approvalHandler, markChangeHandler } = props;


  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, data]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  return (
    <>
      <div className="py-3">
        <div className="row mx-1" style={{ overflowX: "auto" }}>
          <Table className="table w-100" striped bordered hover variant="dark">
            <thead>
              <tr>
                {tableHead &&
                  tableHead.map((heading) => (
                    <th className="bg-warning text-center">{heading}</th>
                  ))}
              </tr>
            </thead>

            <tbody>
              {currentItems &&
                currentItems.map((video, index) => (
                  <tr key={index}>
                    <td>{`${index + 1}`}</td>
                    <td>
                      <div className="row">
                        <div key={index} className="col-md-4">
                          <ReactPlayer
                            controls
                            url={videoCdnUrl + video.video}
                            width="200px"
                            height="100px"
                          />
                        </div>
                      </div>
                    </td>
                    <td>{video?.user_vote_avg_mark}</td>
                    <td>{video?.group_b_jury_mark}</td>
                    <td>{video?.group_c_jury_mark}</td>
                    <td>{video?.group_a_jury_mark}</td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>
      </div>

      <div id="react-paginate">
        <ReactPaginate
          breakLabel="..."
          nextLabel="next >"
          onPageChange={handlePageClick}
          pageRangeDisplayed={3}
          pageCount={pageCount}
          previousLabel="< previous"
          renderOnZeroPageCount={null}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageLinkClassName={"page-link"}
          previousLinkClassName={"page-link"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
        />
      </div>
    </>
  );
};

export default RoundAssessmentResultTable;
